import { render, staticRenderFns } from "./ExperienceStdObForm.vue?vue&type=template&id=5b23a2a2&"
import script from "./ExperienceStdObForm.vue?vue&type=script&lang=js&"
export * from "./ExperienceStdObForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports